import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { QuickLinks } from '@bepure/tarkin';

interface IdLookup {
  title: string;
}

interface TitleCollection {
  titleList: string[];
  idLookup: IdLookup;
}

class Legal extends React.PureComponent {

  public componentDidMount() {
    window.scrollTo(0, 0);
  }

  public render() {
    const quickLinksProps = this.generateTableOfContents();
    return (
      <div>
        <QuickLinks list={quickLinksProps.list} hrefGenerator={quickLinksProps.hrefGenerator} onClick={this.expand} />
      </div>
    );
  }

  private expand() {
      const readMoreButton = document.getElementById('readmore') as HTMLElement;
      const goToTopButton = document.getElementById('goToTop') as HTMLElement;
      const legalPage = document.getElementById('legal_body') as HTMLElement;
      readMoreButton.style.display = 'none';
      legalPage.style.height = '100%';
      goToTopButton.style.display = 'flex';
  }

  private generateTableOfContents() {
    const tableOfContents: TitleCollection = Array.prototype.slice.call(document.getElementsByClassName('legal__body__title')).reduce((acc: TitleCollection, node: HTMLElement) => {
      acc.titleList.push(node.innerHTML);
      acc.idLookup[node.innerHTML] = node.id;
      return acc;
    }, {
      titleList: [],
      idLookup: {},
    });

    return {
        list: tableOfContents.titleList,
        hrefGenerator: (title: string) => tableOfContents.idLookup[title],
    };
  }
}

export default function render() {
  const node: HTMLElement | null = document.getElementById('table-of-contents');
  if (node) {
    return ReactDOM.render(
      <Legal />,
      node,
    );
  }
}
